import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { styled } from '@mui/material/styles';

const CustomLoadingButton = styled(LoadingButton)<LoadingButtonProps>({
  borderRadius: '0',
  padding: '4px 16px',
  height: '32px',
  textTransform: 'none',
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: '600',
  fontStyle: 'normal',
  backgroundColor: 'var(--green)',
  color: 'white',
  '&:hover': {
    backgroundColor: 'var(--lightgreen)',
  },
  '&.clear': {
    backgroundColor: 'white',
    color: 'var(--darkblue)',
    '&:hover': {
      backgroundColor: 'var(--grey)',
    },
  },
});

export default CustomLoadingButton;
